import { Injectable } from "@angular/core";
import { ApplicationPool } from "src/app/services/application.pool";

@Injectable({
  providedIn: "root",
})
export class NotificationSoundService {
  private audio: any;

  get muted(): boolean {
    const res = localStorage.getItem("muted_" + this.pool.User?.id);
    if (res == null) {
      return !this.pool.Library?.configuration?.notificationsEnabled;
    }
    return res == "true";
  }
  private set muted(val: boolean) {
    localStorage.setItem("muted_" + this.pool.User?.id, val ? "true" : "false");
  }

  constructor(private pool: ApplicationPool) {
    this.audio = new Audio();
    this.audio.src = "../assets/notification/notification-900.mp3";
    this.audio.load();
    this.audio.volume = 0.08;
  }

  play() {
    if (!this.muted) {
      this.audio.play();
    }
  }

  mute() {
    this.muted = !this.muted;
  }
}
